module.exports = __webpack_public_path__ + "img/inno_4.f6c3c7b2.jpg";